<template>
    <div class="resumeJob">
        <div v-for="(n,i) in jobList">
            <label>单位名称</label><input type="text" v-model="n.company_name" placeholder="请填写单位名称">
            <label>职位名称</label><input type="text" v-model="n.position_name" placeholder="请填写职位名称">
            <label>工作时间</label><input type="text" v-model="n.work_time_start" placeholder="请填写开始时间" class="start_time">至
            <input type="text" placeholder="请填写结束时间" v-model="n.work_time_end"  class="start_time">
            <label>工作职责</label><textarea  v-model="n.intro" placeholder="请填写工作职责"></textarea>
            <input  name="experience_id" v-model="n.experience_id" style='border:none; font-size:0;width: 0;height: 0;'>
            <div style="clear: both"></div>
            <p class="delete" v-if="i!='0'"><span @click="removeItem(i)">删除</span></p>
        </div>
        <p class="continue">
            <span @click="addResumeJob()">+继续添加</span>
            <span class="save" @click="saveJob()">保存</span>
        </p>
    </div>
</template>

<script>
    // import {Toast} from 'mint-ui';
    export default {
        name: "resumeJob",
        inject: ['showMsg'],
        created: function () {
            console.log(this.jobList)
        },
        data:function(){
            return{
                jobLists:[],
                jobItemId:'0'
            }
        },
        methods: {
            removeItem(jobId) {
                return this.jobList.splice(jobId, 1);
            },
            addResumeJob() {
                 this.jobLists=this.jobList;
                 this.jobLists.push({
                    id: this.jobItemId++,
                    company_name: '',
                    position_name: '',
                    work_time_start: '',
                    work_time_end: '',
                    intro: '',
                    experience_id: ''
                });
                this.$store.commit("set_jobList",this.jobLists);
            },
            saveJob(){
                for(let i= 0 ; i<this.jobList.length;i++){
                    if(this.jobList[i].company_name==''){
                        this.showMsg('请填写单位名称');
                        return false;
                    }
                    if(this.jobList[i].position_name==''){
                        this.showMsg('请填写职位名称');
                        return false;
                    }
                    if(this.jobList[i].work_time_start==''){
                        this.showMsg('请填写开始时间');
                        return false;
                    }
                    if(this.jobList[i].work_time_end==''){
                        this.showMsg('请填写结束时间');
                        return false;
                    }
                    if(this.jobList[i].intro==''){
                        this.showMsg('请填写工作职责');
                        return false;
                    }
                }
                this.$http({
                    url: this.weburl + "/home/job/resumeHandle",
                    method: "POST",
                    dataType: "json",
                    data:{
                        arr:this.jobList ,
                        resume_id:this.end_information,
                        field:"experience"
                    },
                })
                    .then(res => {
                        console.log(res);
                        if (res.data.status == 1) {
                            this.showMsg('保存成功');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
           /* showMsg(msg){
                Toast({
                    message: msg,
                    duration: 1000
                });
            },*/

        },
        computed: {
            jobList: function () {
                return this.$store.state.endPage.jobList;
            },
            end_information: function () {
                return this.$store.state.endPage.end_information;
            },
            weburl: function () {
                return this.$store.state.weburl;
            }


        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/resume.less";

</style>
